import { z } from 'zod/v4';
import type enGB from './locales/en_GB.json';

export const localeCode = ['de', 'en-GB', 'en-US', 'fr', 'it', 'ja', 'nl-BE', 'zh-CN'] as const;
export const localeCodeEnum = z.enum(localeCode);
export type LocaleCode = z.infer<typeof localeCodeEnum>;

export const DEFAULT_LOCALE = localeCodeEnum.enum['en-GB'];

export const LOCALES = {
  de: { locale: localeCodeEnum.enum.de, name: 'Deutsch' },
  'en-GB': { locale: localeCodeEnum.enum['en-GB'], name: 'English (UK)' },
  'en-US': { locale: localeCodeEnum.enum['en-US'], name: 'English (US)' },
  fr: { locale: localeCodeEnum.enum.fr, name: 'Français' },
  it: { locale: localeCodeEnum.enum.it, name: 'Italiano' },
  'nl-BE': { locale: localeCodeEnum.enum['nl-BE'], name: 'Vlaams' },
  ja: { locale: localeCodeEnum.enum.ja, name: '日本語' },
  'zh-CN': { locale: localeCodeEnum.enum['zh-CN'], name: '简体中文' },
} satisfies { [key in LocaleCode]: { locale: key; name: string } };

export type TranslationKey = keyof typeof enGB | (string & {});
